import { writable, derived } from 'utils/state'

const Store = {
  ip: writable(undefined),

  url: writable(''),
  filename: undefined,
  log: writable(undefined),

  hasOpenModal: writable(false)
}

Store.filename = derived(Store.url, url => url && url.split('/').pop())

window.Store = Store
export default Store



// WEBPACK FOOTER //
// ./src/store/store.js